import React from 'react';
import { useAppSelector } from '../../Redux/hooks';
import "./Header.scss";
import { allcontentOrConfigData } from '../../Redux/Reducers/GlobalSlice';
import { getKeyValuePair } from '../../utils/ContentOrConfigUtil';
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from '../../utils/constants';
import { bannerStringGenerator } from '../../utils/validation';
import Banner from '../Banner/Banner';
import AdSign from './AdSign/AdSign';

export interface IHeaderProps { };

const Header: React.FunctionComponent<IHeaderProps> = (props) => {
    const redirectUrl1 = useAppSelector((state: any) => state?.global?.redirectUrl);
    const redirectUrl = useAppSelector((state) => state?.activityDetails?.additionalInfo?.find((item: any) => item.key === "redirectUrl")?.value);
    const contentOrConfigData: any = useAppSelector(allcontentOrConfigData);
    let _role = useAppSelector((state: any) => state?.global?.role) || "";
    let _managedEquipment = useAppSelector((state: any) => state?.global?.managedEquipment);
    const bannerDisplay = getKeyValuePair(contentOrConfigData, CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.banner, bannerStringGenerator(_role, _managedEquipment));
    return <div className={`Header ${bannerDisplay ? "bannerDisp" : ""}`} data-testid="header">
        {bannerDisplay && <Banner />}
        {_role !== "carrierSCDMnoDCI" ?
            <a href={redirectUrl ? redirectUrl : redirectUrl1} target="_blank" rel="noopener noreferrer" data-testid="headerimg1" className='headerimg1'>
                <img src="wizard/assets/images/logo.png"
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = "./assets/images/logo.png";
                    }} alt="Logo" loading="lazy" className="logo" />
            </a> : <img src="wizard/assets/images/logo.png"
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "./assets/images/logo.png";
                }} alt="Logo" loading="lazy" className="logo" />
        }

        {_role === "customerQuote" || _role === "carrierSCDMnoDCI" ?
            <img src="wizard/assets/images/illustrations-carrier.png" onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "./assets/images/illustrations-carrier.png";
            }} alt="Web logo" loading="lazy" className='web_logo' />
            :
            <div className='web_logo'><AdSign /></div>}



    </div>
}
export default Header;